import { Link, Wrapper, ConnectionView, Icon, Inserter, Image, SessionRole } from "nystem-components";
import app from "nystem";

const NavLink = ({ to, match, icon, children }) => (
  <Link
    to={to}
    match={match}
    className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-emerald-50/80 hover:bg-white/10 hover:text-white [&.active]:bg-white/15 [&.active]:text-white"
  >
    <Icon icon={icon} className="h-4 w-4" />
    <Wrapper className="hidden sm:block">{children}</Wrapper>
  </Link>
);

const PartMenu = () => (
  <Wrapper renderAs="header" className="sticky top-0 z-30 bg-emerald-950 shadow print:hidden">
    <Wrapper renderAs="nav" className="mx-auto flex max-w-6xl items-center gap-1 px-4 py-2 md:px-8">
      <Link to="/" className="mr-3 flex items-center gap-2">
        <ConnectionView>
          <Image className="h-10 w-10 rounded-full bg-white p-0.5" src="/image/Arbor_syd_trad.png" width="80" alt="Arbor Syd" />
        </ConnectionView>
        <ConnectionView offline="true">
          <Image
            className="h-10 w-10 rounded-full bg-white p-0.5 grayscale"
            src="/image/Arbor_syd_trad.png"
            width="80"
            alt="Arbor Syd"
          />
        </ConnectionView>
        <Wrapper className="hidden font-semibold text-white md:block">Arbor Syd</Wrapper>
      </Link>
      <SessionRole userrole="logged-in" className="flex items-center gap-1">
        <NavLink to="/" match="/stage/*" icon="list">
          {app.t("Missions")}
        </NavLink>
        <NavLink to="/schedule" icon="calendar-check">
          {app.t("Booked")}
        </NavLink>
        <NavLink to="/customer/list" match="/customer/*" icon="user-group">
          {app.t("Customers")}
        </NavLink>
      </SessionRole>
      <Wrapper className="grow" />
      <Inserter match="*" source="/language/switcher" className="rounded-lg bg-white/90 p-0.5" />
      <SessionRole userrole="config super">
        <NavLink to="/admin" match="/admin*" icon="gear">
          {app.t("Admin")}
        </NavLink>
      </SessionRole>
    </Wrapper>
  </Wrapper>
);

export default PartMenu;
